import { MATRIX_THEME_ID } from '@unifyapps/carbon/theme/const';
import type { FlattenedThemeType } from '@unifyapps/defs/theme/types';
import { buildMatrixThemeStyleString } from './buildMatrixThemeStyleString';

/**
 * writes compiled theme CSS into the matrix `#matrix-theme` StyleOverride node.
 */
export function injectMatrixThemeStyleOverride(
  props: Partial<
    Pick<
      FlattenedThemeType,
      'cssVars' | 'components' | 'styleOverrides' | 'defaultScheme' | 'customFonts'
    >
  > & {
    legacyThemeOutput?: string;
  },
): void {
  if (typeof document === 'undefined') {
    return;
  }
  /** `getElementById` only returns the first match, but duplicate ids can exist
   * here (invalid DOM): one `#matrix-theme` is rendered statically by SSR and
   * another may be injected later. Among rules of equal specificity, the cascade
   * tie-breaks by source order — the latest sibling wins — so we pick the last
   * match to avoid being shadowed by a node that was inserted after ours.
   */
  const matches = document.querySelectorAll(`#${CSS.escape(MATRIX_THEME_ID)}`);
  const styleOverride = matches.length > 0 ? matches[matches.length - 1] : null;
  if (!styleOverride) {
    return;
  }
  styleOverride.textContent = buildMatrixThemeStyleString(props);
}
